<main class="dialog-workshop row">
  <ng-template #loading>
    <div class="loading-container">
      <section>
        <div  class="pulsing">
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing">{{"Searching" | translate}}</p>
      </section>
    </div>
  </ng-template>
  <div class="row">
    <h1 class="col-lg-12 dialog-title">
      {{ workshopRequiredList.workshop ? ('EditWorkshop' | translate) :
      ('AddWorkshop' | translate) }}
    </h1>
  </div>

  <div class="form-container">
    <div class="row">

        <mat-form-field class="col-lg-6">
          <mat-label>{{'SelectBrands' | translate}}</mat-label>
          <mat-select  class="brand-label" [(ngModel)]="brandsSelected" multiple>
              <mat-option *ngFor="let dataItem of workshopRequiredList.workshopRequiredInfo[1]"
              [value]="dataItem.brandId">
                  {{dataItem.brandName}}
              </mat-option>
          </mat-select>
        </mat-form-field>


      <mat-form-field class="col-lg-6 city-dropdown">
        <mat-label>{{"City" | translate}}</mat-label>
        <mat-select [(ngModel)]="cityId">
          <mat-option
            *ngFor="let city of workshopRequiredList.workshopRequiredInfo
              [3]"
            [value]="city.cityId"
            >{{city.cityName}}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field class="col-lg-6">
        <mat-label>{{"NameWorkshop" | translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="workshopName" oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')" />
      </mat-form-field>
      <div class="inputs-validations">
        <mat-form-field class="col-lg-6">
          <mat-label>{{"Address" | translate}}</mat-label>
          <input
            matInput type="text"
            [(ngModel)]="adress"
            (ngModelChange)="validateAddressInput($event)"
          />
        </mat-form-field>
        <div *ngIf="errorMessage" class="error-message">
          <p class="error-ms">
            {{ errorMessage |translate}}
          </p>
        </div>
      </div>

    </div>
    <div class="row">
      <mat-form-field class="col-lg-6">
        <mat-label>{{"Phone" | translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="phone" />
      </mat-form-field>
      <mat-form-field class="col-lg-6">
        <mat-label>{{"chiefOfWorkshop" | translate}}</mat-label>
        <mat-select [(ngModel)]="chiefOfWorkshopId">
          <mat-option
            *ngFor="let chiefOfWorkshop of workshopRequiredList.workshopRequiredInfo
                [2]"
            [value]="chiefOfWorkshop.chiefId"
            >{{chiefOfWorkshop.chiefName}}
            {{chiefOfWorkshop.chiefLastName}}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row services-container">
      <p class="col-lg-12 activate-service-title">
        {{"ActivateDeactiveService" | translate}}
      </p>
      <div
        class="col-lg-6 toggle-container pt-lg-3 pb-lg-3"
        *ngFor="let service of selectedServices"
      >

        <mat-slide-toggle
          *ngIf="service.serviceName !== ''"
          [(ngModel)]="service.isActive"
        >
          {{service.serviceName | translate}}
        </mat-slide-toggle>
      </div>
    </div>
  </div>

  <div class="actions">
    <button mat-dialog-close class="dialog__button">
      {{"Cancel" | translate}}
    </button>
    <button
      cdkFocusInitial
      (click)="onSave()"
      class="dialog__button dialog__button--fill"
      [disabled]="isClearDisabled()"
    >
      {{"Accept" | translate}}
    </button>
  </div>
</main>
